import { FC, useEffect, useState } from "react"

import styles from "./XToolbar.module.scss"
import { useWindowDimensions } from "../../hooks"
import { XIcons, XInputDebounce } from ".."

type XToolbarActionProps = {
  onClick: (ev: any) => void
  children: any
  style?: any
}

type XToolbarSearchProps = {
  searchText: string
  placeholder?: string
  onSearch: (text: string) => void
}

type XToolbarLabelProps = {
  children: any
  autoHeight?: string
}

type XToolbarItemProps = {
  children: any
  ended?: boolean
}

type XToolbarProps = {
  children: any
  id: string
}

type XToolbarBackProps = {
  onClick: (ev: any) => void
}

type XToolbarExtensions = {
  Item: typeof Item
  Back: typeof Back
  Label: typeof Label
  Action: typeof Action
  Search: typeof Search
}

export const XToolbar: FC<XToolbarProps> & XToolbarExtensions = ({
  children, id
}) => {

  const { width } = useWindowDimensions()

  const [fixed, setFixed] = useState(false)

  const getRelativePos = (elm: any, root: any) => {
    let pPos = root.getBoundingClientRect(), // parent pos
        cPos = elm.getBoundingClientRect(), // target pos
        pos: any = {}

        console.log(cPos.top, pPos.top, root.scrollTop)

    pos.top    = cPos.top    - pPos.top + root.scrollTop
    pos.right  = cPos.right  - pPos.right
    pos.bottom = cPos.bottom - pPos.bottom
    pos.left   = cPos.left   - pPos.left

    return pos
  }

  useEffect(() => {

    const root = document.getElementById("root")
    let xtoolbar = document.getElementById(`xtoolbar_${id}`)
    let rel = getRelativePos(xtoolbar, root)

    let inter = setTimeout(() => {
      xtoolbar = document.getElementById(`xtoolbar_${id}`)
      if (xtoolbar != null) {
        rel = getRelativePos(xtoolbar, root)
        clearInterval(inter)
      }
    }, 1000)

    const onScroll = (event: any) => {
      const scrollTop = event.target.scrollingElement.scrollTop
      
      if (scrollTop >= rel.top) {
        setFixed(true)
      } else {
        setFixed(false)
      }
    }
    
    document.addEventListener('scroll', onScroll)

    return () => {
      document.removeEventListener('scroll', onScroll)
    }
  }, [])

  return (
    <>
      <div id={`xtoolbar_${id}`} className={styles.mtb + (fixed && width > 768 ? " " + styles.fixed : "")}>
        <div className={styles.manager_toolbar}>
          {children}
        </div>
      </div>
    </>
  )
}

const Item: FC<XToolbarItemProps> = ({
  children, ended = false
}) => {
  return (
    <>
      <div className={styles.manager_toolbar__item + (ended ? " " + styles.ended : "")}>
        {children}
      </div>
    </>
  )
}

const Action: FC<XToolbarActionProps> = ({
  onClick, children, style = {}
}) => {
  return (
    <>
      <div style={style}><button onClick={onClick}>{children}</button></div>
    </>
  )
}

const Search: FC<XToolbarSearchProps> = ({
  searchText, onSearch, placeholder = "Username / UserID"
}) => {
  return (
    <>
      <div>
        <XInputDebounce debounceTimeout={800} type="text" placeholder={placeholder} value={searchText} onChange={(event: any) => onSearch(event.target.value)} />
      </div>
    </>
  )
}

const Label: FC<XToolbarLabelProps> = ({
  children, autoHeight = "15px"
}) => {
  return (
    <>
      <div style={{height: autoHeight, marginRight: "8px"}}>{children}</div>
    </>
  )
}

const Back: FC<XToolbarBackProps> = ({
  onClick
}) => {
  return (
    <>
      <div onClick={onClick}><span><XIcons name="r arrow-left-long" size="16px" color="#000" /></span></div>
    </>
  )
}

XToolbar.Item = Item
XToolbar.Back = Back
XToolbar.Label = Label
XToolbar.Action = Action
XToolbar.Search = Search